import { datadogLogs } from "@datadog/browser-logs";
import { useEffect } from "react";
import { DefaultPrivacyLevel, datadogRum } from "@datadog/browser-rum";
//#region src/browser/logs.ts
function logs({ config }) {
	datadogLogs.init({
		forwardErrorsToLogs: true,
		...config
	});
}
//#endregion
//#region src/browser/rum.ts
function rum({ config }) {
	datadogRum.init({
		trackUserInteractions: true,
		...config
	});
}
const replay = datadogRum.startSessionReplayRecording;
//#endregion
//#region src/hooks/useBrowserLogger.tsx
/**
* @deprecated
* Remove usage and use `import { logger } from '@legalzoom/logger'`
*/
function useBrowserLogging({ config, features = ["rum", "logs"] }) {
	const { env, service, clientToken, version, applicationId, beforeSendLogs, beforeSendRum, sessionReplaySampleRate } = config;
	const datadogConfig = {
		clientToken,
		site: "datadoghq.com",
		service,
		version,
		env: env || "",
		sampleRate: 100,
		sessionReplaySampleRate: sessionReplaySampleRate || 0,
		premiumSampleRate: 0,
		trackResources: true,
		trackLongTasks: true,
		trackUserInteractions: true,
		defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT
	};
	const availableFeatures = {
		rum: () => rum({ config: {
			applicationId,
			beforeSend: beforeSendRum,
			...datadogConfig
		} }),
		logs: () => logs({ config: {
			beforeSend: beforeSendLogs,
			...datadogConfig
		} }),
		replay
	};
	useEffect(() => {
		features.forEach((feature) => availableFeatures[feature]());
	}, []);
}
//#endregion
export { useBrowserLogging as useLogger };

//# sourceMappingURL=index.mjs.map